import React from 'react'

const OtherSettings = ({ setIsChangePasswordModalOpen }) => {
  return (
    <div className="flex flex-col">
      <span className="text-gray-500 font-bold">Alte setări</span>
      <hr className="w-[60%] bg-over-ternary-background mt-1" />
      <div className="mt-1 flex gap-3 flex-col text-sm font-bold text-over-primary-background ">
        <span
          onClick={() => setIsChangePasswordModalOpen(true)}
          className="hover:text-primary cursor-pointer"
        >
          Schimbă-ți parola
        </span>
        {/*<span className="hover:text-primary cursor-pointer">*/}
        {/*  Deconecteaza-te de pe toate device-urile*/}
        {/*</span>*/}
      </div>
    </div>
  )
}

export default OtherSettings
